module.exports = __webpack_public_path__ + "static/media/brasilia-df.676abed5.jpg";